import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import * as XLSX from 'xlsx';
declare var $: any;

@Component({
  selector: 'app-listhitoryformoney',
  templateUrl: './listhitoryformoney.component.html',
  styleUrls: ['./listhitoryformoney.component.css']
})
export class ListhitoryformoneyComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  @ViewChild('table2') table2: ElementRef;


  farmercode: string;
  chooseyear = '';
  data_select = { year: '', fmcode: '' };
  in_data_ = { year: '', fmcode: '' };

  ngOnInit(): void {
    //this.editor[0] = true;
  }

  async Loaddata() {
    let code = this.data_select.fmcode;
    this.farmercode = code;
    if (code == '') { }
    else {
      this.Loadaskmoney();
      this.Loadfactor();
      //this.check_edit();
    }
  }

  editor = [false, false];
  async check_edit(id: number) {
    if (this.editor[1] && (this.oneaskmoney.length > 0 || this.onefactor.length > 0)) {
      await this.Load_araes_fm(id);
    }
  }

  main_data: any = {};
  Edit_money(item: any) {
    let item1 = { ...item, default_approved: item.credit_approved, credit_max: 0 };
    this.main_data = { ...item1 };
    this.listqueue = [];
    this.listqueue.push({ ...item1 });
    $('#edit_m').modal('show');
    console.log('Edit_item:', this.listqueue);
    /*this.editor[0] = false;
    this.editor[1] = true;     
    this.oneaskmoney = item;
     this.onefactor = this.oneaskmoney.map(el => ({...el, edit: true }));
     */
  }
  listqueue = []
  data_lands: any[] = [];
  sel_landno: any = {};
  async Load_araes_fm(id: number) {
    this.loading[2] = true;
    let stra = '';
    let data = this.data_select;
    if (id == 1) stra = `[v_cp${data.year}_getMoney]`
    else if (id == 2) stra = `[v_cp${data.year}_getFert12]`

    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&t=[dbo].${stra}&w=fmcode='${data.fmcode}'`;
    await axios.get(url).then(res => {
      this.loading[2] = false;
      let data = res.data;
      if (data.length > 0) this.data_lands = data;
      else this.data_lands = [];
    }).catch(err => { throw (err) })
  }

  snaponedata(i: number, data: any) {//** เลือกแปลง  */    
    this.listqueue = this.listqueue.filter(el => el.itid != data.itid);
    if (i == 1) {
      const data0 = { ...this.main_data };
      console.log('listqueue:', this.listqueue);
      //this.listqueue = this.listqueue.filter(data => data.itid !== data.itid)
      data0.itid = data.itid;
      data0.intlandno = data.intlandno;
      data0.credit_approved = 0;
      data0.sum_money_amt = data.sum_money_amt;
      //data0.credit_max = data.balance_limit;
      /*data0 = data0.map((item: any) => {
        return {
          ...item, credit_approved: 0
          , count_copies: item.count_copies + 1
          , sum_money_amt: data.sum_money_amt
          , sum_money_rent: data.sum_money_rent
        };
      });*/
      //console.log('snaponedata2:', data0);
      this.listqueue.push({ ...data0, credit_max: data.balance_rent });
      console.log('snaponedata:', data);
      //this.sel_landno = data;
    }
  }

  get remainingAmount(): number {
    let usedAmount = this.listqueue.slice(1).reduce((sum, item) => sum + Number(item.credit_approved), 0);
    return this.listqueue[0].default_approved - usedAmount;
  }

  validateCreditApproved(index: number) {
    if (index === 0) return;

    let item = this.listqueue[index];
    let remaining = this.remainingAmount;
    if (Number(item.credit_approved) > Number(item.credit_max)) {
      item.credit_approved = Number(item.credit_max); // จำกัดไม่ให้เกิน credit_max
    }
    if (remaining < 0) {
      item.credit_approved = Math.max(0, Number(item.credit_approved) + remaining); // ลดให้พอดีกับยอดเงินคงเหลือ
    }
  }

  txtSearch: string = '';
  loading = [false, false, false];
  // โหลดปัจจัยการผลิต
  onefactor = [];
  async Loadfactor() {
    this.loading[1] = true;
    let data = this.data_select;
    let code = data.fmcode;
    let seyear = data.year;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/search_v_getfactor_w?YearID=" + seyear + "&fmcode_b1=" + code;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&t=[dbo].[v_getfactor${seyear}]&w=fmcode='${code}'`;
    await axios.get(url).then(res => {
      this.loading[1] = false;
      let data = res.data;
      if (data.length > 0) this.onefactor = data;
      else this.onefactor = [];
    }).catch(err => { throw (err) })
  }

  // โหลดปัจจัยการผลิต
  oneaskmoney = [];
  async Loadaskmoney() {
    this.loading[0] = true;
    let data = this.data_select;
    let code = data.fmcode;
    let seyear = data.year;
    this.chooseyear = seyear;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/search_v_getfinance_w?YearID=" + seyear + "&fmcode_b1=" + code;
    let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-2/select_sfw?s=*&t=[dbo].[v_getfinance${seyear}]&w=fmcode='${code}'`;
    axios.get(url).then(res => {
      this.loading[0] = false;
      let data = res.data;
      if (data.length > 0) this.oneaskmoney = data;
      else this.oneaskmoney = [];
    }).catch(err => { throw (err) })
  }

  datainmodal: any;
  Timeline(data: any) {
    this.datainmodal = data//this.oneaskmoney.filter((el: any) => el.docid == id);
  }

  THtoLocalstring(thisdate: any) {
    const date1 = new Date(thisdate);
    let options: any = {
      // weekday: "short",
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  ExportExcel() {
    let wannafind = this.farmercode;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'รายการขอเกี๊ยว ' + this.chooseyear + ' โควตา' + wannafind + '.xlsx');
  }

  ExportExcel2() {
    let wannafind = this.farmercode;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table2.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'รายการขอเบิกปัจจัยการผลิต ' + this.chooseyear + ' โควตา' + wannafind + '.xlsx');
  }

  private colorMap: Map<string, string> = new Map();
  getColor(parcelNumber: string): string {
    if (!this.colorMap.has(parcelNumber)) {
      const randomColor = this.getRandomColor();
      this.colorMap.set(parcelNumber, randomColor);
    }
    return this.colorMap.get(parcelNumber)!;
  }
  getRandomColor(): string {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgba(${r}, ${g}, ${b}, 0.5)`; // โปร่งใส 50%
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.datainmodal = null;
    this.oneaskmoney = null;
    this.onefactor = null;
  }
}
